import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Linked Headings"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "linked-headings"
    }}>{`Linked Headings`}</h1>
    <p>{`Create anchor-linked headings in MDX.`}</p>
    <p>{`Use `}<inlineCode parentName="p">{`remark-slug`}</inlineCode>{` with MDX to create IDs based on the heading's content.
If you're using Gatsby, add this to your `}<inlineCode parentName="p">{`gatsby-plugin-mdx`}</inlineCode>{` options.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "filename=gatsby-config.js",
        "filename": "gatsby-config.js"
      }}>{`const remarkSlug = require('remark-slug')

module.exports = {
  plugins: [
    {
      resolve: 'gatsby-plugin-mdx',
      options: {
        remarkPlugins: [remarkSlug],
      },
    },
  ],
}
`}</code></pre>
    <p>{`Next create a components module to pass to MDX context.
If you're using `}<inlineCode parentName="p">{`gatsby-plugin-theme-ui`}</inlineCode>{`, add a `}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/components.js`}</inlineCode>{` file.
If you're not using Gatsby, pass these components to the `}<a parentName="p" {...{
        "href": "https://mdxjs.com/getting-started#mdxprovider"
      }}><inlineCode parentName="a">{`MDXProvider`}</inlineCode>{` component`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "filename=src/gatsby-plugin-theme-ui/components.js",
        "filename": "src/gatsby-plugin-theme-ui/components.js"
      }}>{`/** @jsxImportSource theme-ui */

const heading = (Tag) => (props) => {
  if (!props.id) return <Tag {...props} />

  return (
    <Tag {...props}>
      <a href={\`#\${props.id}\`}>{props.children}</a>
    </Tag>
  )
}

const components = {
  h1: heading('h1'),
  h2: heading('h2'),
  h3: heading('h3'),
  h4: heading('h4'),
  h5: heading('h5'),
  h6: heading('h6'),
}

export default components
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      